import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SwitchBox } from '../../../molecules/switch-box';
import { SliderBox } from '../../../molecules/slider-box';
import { HelpButton } from '../../../atoms/help-button';
import { Inverter } from '../../../shared';
import { useSelector } from '../../../store/utils';

export const SettingsPvOverflow = () => {
  const fronius = useSelector((s) => {
    const inverterConfig = s.variables.INVERTER_CONFIG;
    const inverterConfigArray = Object.values(inverterConfig ?? {});
    return inverterConfigArray[0]?.type === Inverter.Fronius;
  });

  const largeInstallation = useSelector((s) => s.variables.LARGE_INSTALLATION);

  return (
    <>
      <SwitchBox
        title={
          <FormattedMessage
            id="settings.photovoltaics.overflow"
            defaultMessage="Přetok do sítě bez omezení"
          />
        }
        switchVariableId="PV_OVERFLOW"
        visibility={{
          variableIds: [
            { variableId: 'PV_ONGRID', reversed: true },
            'PV_INSTALL',
            'PV_OVERFLOW_CONTROL',
          ],
        }}
        fullWidth
      />
      <SliderBox
        title={
          <>
            <FormattedMessage
              id="settings.photovoltaics.overflow.value"
              defaultMessage="Omezení přetoku"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.photovoltaics.overflow.value"
                  defaultMessage="Omezení přetoku"
                />
              }
              content={
                fronius ? (
                  <FormattedMessage
                    id="settings.photovoltaics.overflow_fronius.value.help"
                    defaultMessage="Hodnota přetoku na straně Fronius střídače. Slouží jako informace Infigy pro správnou vizualizaci přetoků."
                  />
                ) : (
                  <FormattedMessage
                    id="settings.photovoltaics.overflow.value.help"
                    defaultMessage="Hodnota omezení přetoku do distribuční sítě. Tato hodnota se zapíše do střídače. Ve střídači tuto hodnotu neupravujte. Omezení přetoku je řízené z Infigy. Zapsanou hodnotu si zkontrolujte ve střídači."
                  />
                )
              }
            />
          </>
        }
        variableId="PV_OVERFLOW_MAX_VALUE"
        visibility={{
          variableIds: [
            { variableId: 'PV_ONGRID', reversed: true },
            'PV_INSTALL',
            { variableId: 'PV_OVERFLOW', reversed: true },
            'PV_OVERFLOW_CONTROL',
          ],
        }}
        opts={{
          style: 'unit',
          unit: 'kilowatt',
          maximumFractionDigits: 1,
          minimumFractionDigits: 1,
        }}
        step={largeInstallation ? 1 : 0.1}
        min={0}
        max={largeInstallation ? 200 : 60}
      />
    </>
  );
};
